import { Component, OnInit, OnDestroy, OnChanges, Input, SimpleChanges, ViewChild } from '@angular/core';
import { PlanificadorService } from '../control.service';
import { Subscription } from 'rxjs';
import { auditTime } from 'rxjs/operators';
import { MatTableDataSource } from '@angular/material/table';
import { operationinterface } from 'src/app/interface/OperationInterface';
import { CdkVirtualScrollViewport, ScrollingModule } from '@angular/cdk/scrolling';
import { TableColmuns } from 'src/app/interface/TableColumnsinterface';
//CDK TABLE DESDE ACA
import { CdkTable } from '@angular/cdk/table';
import { CdkTableVirtualScrollDataSource } from 'ng-table-virtual-scroll';
import { DiversificadorService } from 'src/app/services/diversificador.services';
import { GestionService } from 'src/app/services/gestion.services';
import { BrokerService } from 'src/app/services/broker.services';
import { ToastrService } from 'ngx-toastr'; // Asegúrate de importar ToastrService
import { TemaService } from 'src/app/services/tema.services';


@Component({
  selector: 'app-operations',
  templateUrl: './operations.component.html', 
  styleUrl: './operations.component.scss'
})
export class OperationsComponent implements OnDestroy, OnInit, OnChanges {

  panelOpenState = false;
  colPanelOpen = false;
  expandirColPanel() { this.colPanelOpen = true; }
  contraerColPanel() { this.colPanelOpen = false; }
  public carteraOptimaSubcription = new Subscription;
  public operationSubcription = new Subscription;
  public fechaSubcription =  new Subscription;
  public divFechaSubscription = new Subscription;
  public divOperacion = new Subscription;
  public gestFechaSub= new Subscription;
  public gestOperacionSub = new Subscription;
  public brokFechaSub= new Subscription;
  public brokOperacionSub = new Subscription;
  public subTemaService: Subscription = new Subscription;
  public isDark: boolean = false;

  public combinedData : any[]=[];
  public datasource = new MatTableDataSource;
  public cdkTableData : CdkTableVirtualScrollDataSource<operationinterface>;
  public divDataOpe : CdkTableVirtualScrollDataSource<operationinterface>;
  public GestDataOpe : CdkTableVirtualScrollDataSource<operationinterface>;
  public BrokDataOpe : CdkTableVirtualScrollDataSource<operationinterface>;
  public indexop: any;
  public indexopDiv: any;
  public indexGest: any;
  public indexBrok: any;

  /* para la CDK table */
  //viewportOperaciones
  @ViewChild(CdkVirtualScrollViewport, { static: false })  viewportOperaciones!: CdkVirtualScrollViewport;
  @ViewChild(CdkVirtualScrollViewport, { static: false })  viewportOperacionesDiv!: CdkVirtualScrollViewport;
  @ViewChild(CdkVirtualScrollViewport, { static: false })  viewportOperacionesGest!: CdkVirtualScrollViewport;
  @ViewChild(CdkVirtualScrollViewport, { static: false })  viewportOperacionesBrok!: CdkVirtualScrollViewport;
  @Input() selectedTab: number =0;
  @Input() loading: boolean = false;
  @Input() modelo: boolean = false;
  @Input() isPlanificador: boolean = false;
  @Input() isGestion: boolean = false;
  @Input() isBroker: boolean = false;

  tableColumns : TableColmuns []=[
    {id: 'numlinea', name:'N° Operaciones', isShow: true, isDate: false, isNumber: false, isString: true},
    {id: 'contador', name:'N° Compañias', isShow: true, isDate: false, isNumber: false, isString: true},
    {id: 'isooper', name:'ID', isShow: false, isDate: false, isNumber: false, isString: true},
    {id: 'tipomodelo', name:'Tipo Modelo', isShow: true, isDate: false, isNumber: false, isString: true},
    {id: 'nombreCompania', name:'Compañia', isShow: true, isDate: false, isNumber: false, isString: true},
    {id: 'fechaCompra', name:'Fecha Entrada', isShow: true, isDate: true, isNumber: false, isString: false},
    {id: 'fechaOperacion', name:'Fecha Salida', isShow: true, isDate: true, isNumber: false, isString: false},
    {id: 'tipoOperacion', name:'Tipo', isShow: false, isDate: false, isNumber: false, isString: true},
    {id: 'precioentradareal', name:'Entrada', isShow: true, isDate: false, isNumber: true, isString: false},
    {id: 'preciosalidareal', name:'Salida', isShow: true, isDate: false, isNumber: true, isString: false},
    {id: 'cantidadacciones', name:'N° Acciones', isShow: true, isDate: false, isNumber: true, isString: false},
    {id: 'stoplossinicial', name:'Stoploss', isShow: false, isDate: false, isNumber: true, isString: false},

    {id: 'profit', name:'Profit', isShow: false, isDate: false, isNumber: true, isString: false},
    {id: 'posicionsimultanea', name:'Cartera', isShow: false, isDate: false, isNumber: true, isString: false},
    {id: 'beneficioperdida', name:'Beneficio', isShow: true, isDate: false, isNumber: true, isString: false},
    {id: 'beneficioperdidapor', name:'Beneficio %', isShow: true, isDate: false, isNumber: true, isString: false},
    
    {id: 'beneficioacumulado', name:'Beneficio Acumulado', isShow: false, isDate: false, isNumber: true, isString: false},
    {id: 'costereembolso', name:'Reembolso/Devolucion', isShow: false, isDate: false, isNumber: true, isString: false},
    {id: 'podercompra', name:'Poder Adquisitivo', isShow: false, isDate: false, isNumber: true, isString: false},
    {id: 'riesgomaximo', name:'Riesgo Maximo', isShow: false, isDate: false, isNumber: true, isString: false},

   ];

   displayedColumns: string[] = ['numlinea','contador','tipomodelo', 'nombreCompania', 'fechaCompra','fechaOperacion',
                                'precioentradareal','preciosalidareal','cantidadacciones','beneficioperdida'];
  filaSeleccionada: any;
  contadorFilas: number;
  queryParams: string;

  constructor(public _controlService: PlanificadorService,
              public _diversificadorsv: DiversificadorService,
              public _gestorsv: GestionService,
              public _brokersv: BrokerService,    private toastr: ToastrService,
              private temaservicio: TemaService

    ){
  
    this.cdkTableData = new CdkTableVirtualScrollDataSource<operationinterface>();
    this.divDataOpe = new CdkTableVirtualScrollDataSource<operationinterface>();
    this.GestDataOpe = new CdkTableVirtualScrollDataSource<operationinterface>();
    this.BrokDataOpe =  new CdkTableVirtualScrollDataSource<operationinterface>();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(this.selectedTab === 1){
      this.actualizarViewport();
      if(this.modelo){
        if (this.indexop !== -1) {
          const rowHeight = 29.8;
          const scrollToOffset = (this.indexop )* rowHeight;  
          this.viewportOperaciones.scrollToOffset(scrollToOffset);
          console.log(scrollToOffset);
        } 
      }else if(this.isPlanificador){
        if (this.indexopDiv !== -1) {
          const rowHeight = 29.8;
          const scrollToOffset = (this.indexopDiv )* rowHeight;  
          this.viewportOperacionesDiv.scrollToOffset(scrollToOffset);
          console.log(scrollToOffset);
        } 
      }else if(this.isGestion){
        if (this.indexGest !== -1) {
          const rowHeight = 29.8;
          const scrollToOffset = (this.indexGest )* rowHeight;  
          this.viewportOperacionesGest.scrollToOffset(scrollToOffset);
          console.log(scrollToOffset);
        }
      }else if(this.isBroker){
        if (this.indexBrok !== -1) {
          const rowHeight = 29.8;
          const scrollToOffset = (this.indexBrok )* rowHeight;  
          this.viewportOperacionesBrok.scrollToOffset(scrollToOffset);
          console.log(scrollToOffset);
        }
      }

    }

  }

  ngOnInit(): void {

    this.operationSubcription = this._controlService.ventas$.pipe(auditTime(300)).subscribe({
      next: (data: any)=>{
        this.combinedData =(this.flattenArray(data));
        this.combinedData = this.updateCounter(this.combinedData);           
        this.cdkTableData.data = this.combinedData;
      }
    });
    this.fechaSubcription = this._controlService.valFechaFiltro$.subscribe({
      next: (data:any)=>{
        if(data != ''){this.scrollToFirstDate(data);}
      }
    });
    //-----------------DIVERSIFICADOR
    this.divOperacion = this._diversificadorsv.valDivVentas$.pipe(auditTime(300)).subscribe({
      next: (data: any)=>{
        let combinedata = this.flattenArray(data);
        combinedata = this.updateCounter(combinedata);
        this.divDataOpe.data = combinedata;
      }
    });
    this.divFechaSubscription = this._diversificadorsv.valDivFechaFiltro$.subscribe({
      next: (data:any)=>{
        if(data != ''){this.scrollToFirstDate(data);}
      }
    });
    //---------------------GESTOR
    this.gestFechaSub = this._gestorsv.valGestFechaFiltro$.subscribe({
      next: (data: any)=>{
        this.scrollToFirstDate(data);
      }
    });
    this.gestOperacionSub = this._gestorsv.valGestVentas$.pipe(auditTime(300)).subscribe({
      next: (data: any)=>{
        let combinedata = this.flattenArray(data);
        combinedata = this.agregaTiporModelo(combinedata);
       // this.GestDataOpe.data = combinedata;
        combinedata = this.updateCounter(combinedata);
        this.GestDataOpe.data = combinedata;
      }
    });
    //---------------------BROKER
    this.brokFechaSub = this._brokersv.valBrokFechaFiltro$.subscribe({
      next: (data: any)=>{
        this.scrollToFirstDate(data);
      }
    });
    this.brokOperacionSub = this._brokersv.valBrokVentas$.pipe(auditTime(300)).subscribe({//ca
      next: (data: any)=>{
        let combinedata = this.flattenArray(data);
        combinedata = this.updateCounter(combinedata);
        this.BrokDataOpe.data = combinedata;
      }
    });
    this.subTemaService = this.temaservicio.valDarkTheme.subscribe({
      next: (data: any) => { this.isDark = data; }
    });
  }

  flattenArray(arrayOfArrays: any[]): any[] {
    return arrayOfArrays.flatMap(innerArray => innerArray);
  }


  agregaTiporModelo(data :any[] ): any[] {

    return data.map(data => {
     
      if (data && typeof data.bajista === 'boolean' && !data.nombreCompania !== null) {
        
        
          const updatedOperation = {
            ...data,
            tipomodelo: data.bajista ? 'Bajista ↓' : 'Alcista ↑',
          };
    
          // Si 'bajista' es true, agrega la flecha hacia abajo al final de 'tipoOperacion'
          if (data.bajista && typeof data.tipoOperacion === 'string' ) {
            if(data.tipoOperacion === 'SALIDA'){

              updatedOperation.tipoOperacion = `ENTRADA ↓`;

            } else if( data.tipoOperacion === 'ENTRADA'){
              updatedOperation.tipoOperacion = `SALIDA ↓`;

            }

          }else if (!data.bajista && typeof data.tipoOperacion === 'string'){
            if(data.tipoOperacion === 'SALIDA' || data.tipoOperacion === 'ENTRADA') {
              updatedOperation.tipoOperacion = `${data.tipoOperacion} ↑`;
            }
          
          }
    
          return updatedOperation;
        
      } else {
        throw new Error("El objeto no tiene la propiedad 'bajista' o no es un string.");
      }
    });
  }

  updateCounter(data: operationinterface[]): operationinterface[] {
    this.contadorFilas = 0; 
    return data.map(item => {
        let numlinea;
        
        if (item.nombreCompania !== null) {
            numlinea = ++this.contadorFilas; 
        } else {
            numlinea = 'TOTAL'; // Asigna 0 si nombreCompania es null
        }

        // Devuelve un nuevo objeto que incluye todas las propiedades originales más numlinea
        return {
            ...item,
            numlinea
        };
    });
}

  toggleColumnVisibility(id: any){
    const column = this.tableColumns.find(col => col.id === id);
    if (column) {
      column.isShow = !column.isShow;
      this.displayedColumns = this.tableColumns.filter(col => col.isShow).map(col => col.id);
    }
  }

  scrollToFirstDate(date: string) {
    if(this.modelo){
      this.indexop = this.cdkTableData.data.findIndex(item => item.fechaOperacion === date); 

    }else if(this.isPlanificador){
      this.indexopDiv = this.divDataOpe.data.findIndex(item => item.fechaOperacion === date); 
    }else if(this.isGestion){
      this.indexGest = this.GestDataOpe.data.findIndex(item => item.fechaOperacion === date);
    }else if(this.isBroker){
      this.indexBrok = this.BrokDataOpe.data.findIndex(item => item.fechaOperacion === date);
    }

  }

  selectRow(row: any){
    this.filaSeleccionada=row;
    if(this.modelo){
      console.log(" if(this.modelo){ Operations",this.filaSeleccionada.fechaOperacion);
      this._controlService.updateFechaFiltro(this.filaSeleccionada.fechaOperacion);
    }
    else if(this.isPlanificador){this._diversificadorsv.updateDivFechaFiltro(this.filaSeleccionada.fechaOperacion);}
    else if(this.isGestion){this._gestorsv.updategestFechaFiltro(this.filaSeleccionada.fechaOperacion);}
    else if(this.isBroker){this._brokersv.updateBrokFechaFiltro(this.filaSeleccionada.fechaOperacion);}
  }

  ngOnDestroy(): void {
    this.carteraOptimaSubcription.unsubscribe();
    this.operationSubcription.unsubscribe();
    this.divOperacion.unsubscribe();
    this.gestFechaSub.unsubscribe();
    this.gestOperacionSub.unsubscribe();
    this.brokFechaSub.unsubscribe();
    this.brokOperacionSub.unsubscribe();
    this.subTemaService.unsubscribe();
  }
  actualizarViewport() {

    if (this.viewportOperaciones) {
      this.viewportOperaciones.checkViewportSize();
      this.viewportOperaciones.checkViewportSize();
    }
    else if(this.viewportOperacionesDiv){
      this.viewportOperacionesDiv.checkViewportSize();
      this.viewportOperacionesDiv.checkViewportSize();
    }  else if(this.viewportOperacionesGest){
      this.viewportOperacionesGest.checkViewportSize();
      this.viewportOperacionesGest.checkViewportSize();
    } else if(this.viewportOperacionesBrok){
      this.viewportOperacionesBrok.checkViewportSize();
      this.viewportOperacionesBrok.checkViewportSize();
    }

  }

  verGrafica() {
    const jsonData = {
      idNectum: this.filaSeleccionada.idNectum,
      nombreComp: this.filaSeleccionada.nombreCompania,
      idModelo: this.filaSeleccionada.idcartera.toString(),
      isModelo: 'grafica'
    };
    this.queryParams = new URLSearchParams(jsonData).toString();
    window.open('/grafica-modelo/' + this.queryParams, '_blank');

  }

  verModelo() {
    console.log(this.filaSeleccionada);
    if (this.filaSeleccionada.idmodelo > 0) {
      const jsonData = {
        idNectum: this.filaSeleccionada.idNectum,
        nombreComp: this.filaSeleccionada.nombreCompania,
        idModelo: this.filaSeleccionada.idmodelo,
        isModelo: 'modelo',
        fecha: this.filaSeleccionada.fechaOperacion
      };
      this.queryParams = new URLSearchParams(jsonData).toString();
      window.open('/grafica-modelo/' + this.queryParams, '_blank');
    } else {
      this.toastr.error('Selecciona correctamente el activo para ver modelo.', 'Aviso');
    }
  }
}
